// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__269gK","colCheckbox":"styles_colCheckbox__2bDMd"};